{
  "appVersion": "2026-11-04-develop-6700-2251f5a",
  "forceUpdate": false
}
